import React, { lazy, Suspense } from "react";
const LayoutHomeThree = lazy(
  () => import("@/Layout/HomeThree/LayoutHomeThree")
);

const LoginPage = lazy(() => import("@/Components/Login/LoginPage"));

const PageLogin = () => {
  return (
    <Suspense>
      <LayoutHomeThree toLink={"/Electrónicav2"} PLP={false}>
        <div className="ps-my-account">
          <div className="container">
            <LoginPage />
          </div>
        </div>
      </LayoutHomeThree>
    </Suspense>
  );
};

export default PageLogin;
